(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/oddset-most-played/assets/javascripts/oddset-most-played.js') >= 0) return;  svs.modules.push('/widgets/oddset-most-played/assets/javascripts/oddset-most-played.js'); "use strict";

(function (svs) {
  'use strict';

  svs.widget = svs.widget || {};
  svs.widget.oddsetMostPlayed = svs.widget.oddsetMostPlayed || {};
  var log = svs.core.log.getLogger('widget:oddset-most-played');

  svs.widget.oddsetMostPlayed.OddsetMostPlayed = function (options) {
    var $el = options.$el,
        contentReveal = new svs.components.ContentReveal({
      el: $el.find('.js-oddset-most-played-widget')
    });
    $el.off('click', '.js-oddset-most-played-button').on('click', '.js-oddset-most-played-button', playNow);
    $el.off('click', '.js-oddset-most-played-panel').on('click', '.js-oddset-most-played-panel', drawLink);
    startSubscription(); 

    var storedPlayNow = svs.components.Storage.browser.get('oddsetMostPlayed', 'playnow');

    if (storedPlayNow && Object.prototype.hasOwnProperty.call(storedPlayNow, 'drawId') && Object.prototype.hasOwnProperty.call(storedPlayNow, 'eventNumber')) {
      showPlayNow(storedPlayNow);
    }

    function startSubscription() {
      if (svs.widget.oddset_most_played.data.model && svs.widget.oddset_most_played.data.model.draws) {
        svs.widget.oddset_most_played.data.model.draws.forEach(function (draw) {
          if (draw && draw.draw) {
            update(draw.draw);
            subscribeDrawEvent(draw.draw.draw.id);
          }
        });
      }
    }

    function subscribeDrawEvent(drawId) {
      if (!svs.oddset.global) {
        svs.core.socket.subscribe(subscriptionUrl(drawId), update, {});
      }
    }

    function subscriptionUrl(drawId) {
      return "/draw/oddset/draws/".concat(drawId, "/list");
    }

    function unsubscribeDrawEvent(drawId) {
      svs.core.socket.unsubscribe(subscriptionUrl(drawId), update);
    }

    function update(drawObject, oldDrawId) {
      var draw = parseDraw(drawObject);
      var drawData = null;

      if (draw && (draw.drawStateId === svs.oddset.STATE_CLOSED || draw.drawStateId === svs.oddset.STATE_CLOSED_REGULAR)) {
        unsubscribeDrawEvent(draw.id); 

        if (draw.categoryId === svs.oddset.REGULAR && draw.relatedLiveDrawNumber !== 0) {
          transitionToLive(draw);
        } else {
          handleGameNotFound(draw.id);
        }
      } else {
        if (draw && parseDrawEvent(draw)) {
          drawData = svs.sport.oddsetCommon.common.formatDrawData(draw, true);
          render({
            draw: drawData,
            initObject: svs.sport.matchInitBoxLight.createInit(drawData.draw)
          }, oldDrawId);
        } else {
          handleGameNotFound(draw.id);
        }
      }
    }

    function render(model, drawId) {
      var $drawEl = $(".js-oddset-most-played-draw-".concat(drawId && typeof drawId === 'number' ? drawId : model.draw.draw.id));

      if (model && model.draw && model.draw.draw && model.draw.draw.league && model.draw.draw.league.id) {
        model.draw.draw.isHighLeague = svs.sport.sport_common.isHighlightedLeague(model.draw.draw.league.id);
      }

      model.trackingId = $drawEl.find('.js-oddset-most-played-panel').data('track');
      model.areaName = $drawEl.find('.js-oddset-most-played-panel').data('area-name');
      $drawEl.html(svs.widget.oddset_most_played.templates.draw(model));
      $.data($drawEl, 'draw', model.draw);
    }

    function transitionToLive(draw) {
      svs.core.jupiter.call({
        method: 'GET',
        path: "/draw/mixen/draws/".concat(draw.relatedLiveDrawNumber)
      }, function (data) {
        if (!data || !data.draw || !data.draw.id) {
          log.error("Missing draw id with draw number:".concat(draw.relatedLiveDrawNumber));
        } else {
          update(data, draw.id);
          subscribeDrawEvent(data.draw.id);
        }
      }, function () {
        log.error("Failed to fetch live draw with draw id:".concat(draw.relatedLiveDrawNumber));
      });
    }

    function parseDraw(drawObject) {
      if (!drawObject || !drawObject.draw) {
        return log.error('Draw not found');
      }

      return drawObject.draw;
    }

    function parseDrawEvent(draw) {
      if (!draw.events || draw.events === 0 || draw.events.length === 0) {
        log.error("Events not found in draw with draw id: ".concat(draw.id));
        return false;
      }

      if (draw.events[0].eventStateId !== svs.oddset.STATE_OPEN) {
        log.warn("The 1X2 event was closed on draw with draw id: ".concat(draw.id));
        return false;
      }

      return true;
    }

    function trackClick(el, callback) {
      var $el = $(el),
          track = $el.data('track'),
          areaName = $el.data('areaName') || 'unknown';

      if (track) {
        svs.components.analytics.trackPromoClick({
          id: track,
          name: track,
          position: areaName
        }, callback);
      }
    }

    function drawLink(e) {
      e.preventDefault();
      var url = $(this).attr('href');
      trackClick(this, function () {
        window.location.href = url;
      });
    }


    function showPlayNow(options) {
      var $drawEl = $(".js-oddset-most-played-draw-".concat(options.drawId));
      svs.components.loader.show();
      svs.core.module.load('/cl/sport/oddset-play', null, function (error) {
        if (error) {
          svs.components.loader.hide();
          svs.components.Alert('Kunde inte ladda spelet - Försök igen!', {
            time: svs.components.Alert.Time.SHORT,
            type: svs.components.Alert.Type.ERROR
          }).show(null);
        } else {
          svs.sport.oddsetplay.showPlayNow(options.drawId, options.eventNumber, options.description, $.data($drawEl, 'draw'));
        }
      }, false);
    }

    function playNow(e) {
      e.stopPropagation();
      e.preventDefault();
      trackClick(this);
      var self = $(this),
          drawId = self.data('draw-id');
      var game = {
        drawId: drawId,
        eventNumber: self.data('event-number'),
        description: self.data('event-description')
      }; 

      svs.components.Storage.browser.remove('oddsetMostPlayed', 'playnow'); 

      if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.components.Storage.browser.set('oddsetMostPlayed', 'playnow', game, undefined);
      }

      showPlayNow(game);
    }

    function handleGameNotFound(drawId) {
      var $drawEl = $(".js-oddset-most-played-draw-".concat(drawId));
      render({
        draw: null
      }, drawId);

      if (contentReveal) {
        $drawEl.parents('.js-content-reveal-list-item').addClass('content-reveal-list-item-hidden');
        contentReveal.resize();
      } else {
        $drawEl.addClass('oddset-most-played-draw-hidden');
      }
    }
  };

  svs.widget.oddset_most_played = svs.widget.oddset_most_played || {};

  svs.widget.oddset_most_played.init = function (options) {
    new svs.widget.oddsetMostPlayed.OddsetMostPlayed(options);
  };
})(svs);
 })(window);